__turbopack_context__.v({
  "advLine": "AdvLine-module-scss-module__CKSP3W__advLine",
  "content": "AdvLine-module-scss-module__CKSP3W__content",
  "imageWrap": "AdvLine-module-scss-module__CKSP3W__imageWrap",
  "link": "AdvLine-module-scss-module__CKSP3W__link",
  "subtitle": "AdvLine-module-scss-module__CKSP3W__subtitle",
  "text": "AdvLine-module-scss-module__CKSP3W__text",
  "title": "AdvLine-module-scss-module__CKSP3W__title",
});
